import globalConfig from '@/lib/http/global-config'

export const hostToBusinessInfo = () => {
  const defaultConfig = {
    name: '杭州天谷信息科技有限公司',
    tel: '0571-85785223',
  }
  const config = {
    'guangzhou.esign.cn': {
      name: '广州易签宝网络科技有限公司',
      tel: '0571-88231350',
    },
  }

  return config[window.location.hostname] || defaultConfig
}

export const userAgreement = {
  enable: true,
  link: '#',
}

export const polling = (doing, end) => {
  if (!doing) {
    return end && end()
  }
  let timer = setInterval(() => {
    doing(() => {
      timer && clearInterval(timer)
      timer = null
      end && end()
    })
  }, 1000)

  return timer
}

// 数据后端留存
export const dataRetained = ($axios, data) => {
  $axios({
    url: 'v1/facade/customer/lead/',
    method: 'post',
    baseURL: globalConfig.webServer,
    data: {
      ...data,
      source: 'landing', // 落地页-landing 官网-esign
      extendData: JSON.stringify({
        $url: window.location.href, // 页面地址
        platform: 'landing', // 平台, 落地页-landing 官网-esign
        agreementCheck: true, // 已勾选协议
      }),
    },
  })
}

// 20230413迭代，增加企业名称支持联想输入，搜索企业
export const getOrgList = ($axios, orgName, hideLoading = false) => {
  return $axios({
    url: `https://ttapi.tsign.cn/webserver/v1/saas-common/organizations/queryByName?orgName=${orgName}`,
    method: 'GET',
    fullResponse: true,
    hideLoading,
  })
}
export default {
  hostToBusinessInfo,
  userAgreement,
  dataRetained,
}
